"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            maxWidth: '100%',
            width: '100%',
        },
        formControl: {
            width: '100%',
        },
        errorContainer: {
            marginTop: 3,
            minHeight: 16,
            marginBottom: -16,
        },
        errorText: {},
        chevron: {
            marginTop: -14,
            marginRight: 4,
            cursor: 'pointer',
        },
        circularProgress: {
            marginTop: -10,
            marginRight: 6,
        },
        inputWithChevron: {
            paddingRight: 4,
        },
        tagContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            margin: '16px -4px -4px -4px',
            '& > *': {
                margin: 4,
            },
        },
        inputDiv: {
            position: 'relative',
        },
    });
});
